import { formatDistanceToNow, format } from "date-fns"
import { he } from "date-fns/locale"

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return "-"
  try {
    return formatDistanceToNow(new Date(iso), { addSuffix: true, locale: he })
  } catch {
    return "-"
  }
}

export function formatAbsolute(iso: string | null | undefined): string {
  if (!iso) return "-"
  try {
    return format(new Date(iso), "dd/MM/yyyy HH:mm:ss", { locale: he })
  } catch {
    return "-"
  }
}

export function formatBytes(n: number | null | undefined): string {
  if (n == null) return "-"
  if (n < 1024) return `${n} B`
  const units = ["KB", "MB", "GB", "TB"]
  let v = n / 1024
  let u = 0
  while (v >= 1024 && u < units.length - 1) {
    v /= 1024
    u++
  }
  return `${v.toFixed(v < 10 ? 2 : 1)} ${units[u]}`
}

/** מחזיר את הדומיין (hostname ללא www) מתוך כתובת מלאה, או null אם לא ניתן לפענח. */
export function domainFromUrl(url: string | null | undefined): string | null {
  if (!url) return null
  try {
    const host = new URL(url).hostname
    return host.replace(/^www\./, "")
  } catch {
    return null
  }
}

export function formatUptime(ms: number | null | undefined): string {
  if (ms == null) return "-"
  const s = Math.floor(ms / 1000)
  const d = Math.floor(s / 86400)
  const h = Math.floor((s % 86400) / 3600)
  const m = Math.floor((s % 3600) / 60)
  const sec = s % 60
  const parts: string[] = []
  if (d > 0) parts.push(`${d} י׳`)
  if (h > 0) parts.push(`${h} ש׳`)
  if (m > 0) parts.push(`${m} ד׳`)
  if (parts.length === 0) parts.push(`${sec} ש׳`)
  return parts.join(" ")
}
